import React from 'react'
import loadingLogo from '../../../assets/loading.svg'
export class LoadingBanner extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div style={{
        position: 'fixed', width: '100vw', height: '100vh', background: 'black', opacity: '0.2', top: 0, right: 0,
      }}>
        <div style={{
          height: 100, width: 100,
          marginLeft: '47vw',
          marginTop:'30vh',
          borderRadius:100,
          zIndex: 100,
          backgroundColor: 'gray'
        }}>
          <img src={loadingLogo} style={{ animation: `spin 3s linear infinite`}} />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/selectionMenu/components/loadingBanner.jsx